import CrudRepository from './CrudRepository'
export default class DownloadFinancialReports extends CrudRepository {
  constructor () {
    super('customerCare/api/financeReport/download')
  }
}
